import { useTranslation } from 'react-i18next'
import BefehlFormAuftrag from '../Generic/BefehlFormAuftrag'

export interface Auftrag30_10FormProps {
  'data-testid': string
}

export default function Auftrag30_10Form({
  'data-testid': testId
}: Readonly<Auftrag30_10FormProps>) {
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="30.10"
      fieldName="auftrag30_10.enabled"
      readOnly={true}
      testId={testId}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.30_10.label')}</span>
    </BefehlFormAuftrag>
  )
}
